import { useTranslation } from 'react-i18next'
import { useCallback, useState } from 'react'
import {
  Alert,
  Card,
  CardBody,
  CardHeader,
  CardTitle,
  SelectListSingle
} from '@/common'
import { StepFooter } from '@/shared/components'

export default function ProductionRouteWasteGas({
  next,
  previous,
  initialValues
}: {
  next: (payload: { isUsingWasteGas: boolean }) => void
  previous: () => void
  initialValues: {
    isUsingWasteGas: boolean | null
  }
}) {
  const { t } = useTranslation()

  const [isUsingWasteGas, setIsUsingWasteGas] = useState<boolean | null>(
    initialValues.isUsingWasteGas
  )

  const onPreviousClick = useCallback(() => {
    previous()
  }, [previous])

  const onNextClick = useCallback(() => {
    if (isUsingWasteGas === null) {
      return
    }
    next({
      isUsingWasteGas
    })
  }, [isUsingWasteGas, next])

  const isNextButtonEnabled = isUsingWasteGas !== null

  return (
    <div className="space-y-4">
      <Card>
        <CardHeader>
          <CardTitle title={t('productionRoute:wasteGas.title')} />
        </CardHeader>
        <CardBody className="space-y-4">
          <Alert type="info" className="whitespace-pre-line">
            {t(`productionRoute:wasteGas.info`)}
          </Alert>
          <div className="space-y-2">
            <p className="text-sm">{t('productionRoute:wasteGas.description')}</p>
            <SelectListSingle<boolean>
              className="space-y-2"
              name="wasteGas"
              onChange={value => {
                setIsUsingWasteGas(value)
              }}
              items={[
                {
                  id: 'true',
                  label: t('common:yes'),
                  value: true,
                  isChecked: isUsingWasteGas === true
                },
                {
                  id: 'false',
                  label: t('common:no'),
                  value: false,
                  isChecked: isUsingWasteGas === false
                }
              ]}
            />
          </div>
        </CardBody>
      </Card>
      <StepFooter
        onPrevious={onPreviousClick}
        onNext={onNextClick}
        isNextEnabled={isNextButtonEnabled}
      />
    </div>
  )
}
